import React from "react";
import { STATUS_LABELS, STATUS_STYLES } from "@/lib/constants";

export function StatusBadge({ status, className = "" }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-3 py-0.5 text-xs font-semibold ${STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200"} ${className}`}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}
